import React from 'react';
import { Select } from 'antd';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import SupplierRegionsLocationsTreeSelect from '../regions_tree_select/SupplierRegionsLocationsTreeSelect';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const TECH_TARGET_COLLECTION = 'wrenchModeLogsTechFilter';
const LOCATION_TARGET_COLLECTION = 'wrenchModeLogsLocationFilter';

interface WrenchModeLogsHeaderProps {
	filters: { supplierEmail?: string; locationIds?: number[] };
	onFilterChange: (filters: any) => void;
	fieldTechsState: any;
	fetchFieldTechs: (
		params: any,
		targetCollectionName: string,
		pagination?: any,
		sorting?: any,
		filters?: any,
		addToTargetCollection?: boolean
	) => void;
	fetchMultipleFieldTechs: (ids: string[], targetCollectionName?: string) => void;
}

const WrenchModeLogsHeader: React.FC<WrenchModeLogsHeaderProps> = ({
	filters,
	onFilterChange,
	fieldTechsState,
	fetchFieldTechs,
	fetchMultipleFieldTechs,
}) => {
	return (
		<div className="flex items-center gap-s">
			<div className="h4medium text-character-primary">Work Logs</div>
			<OWAsyncSelect
				style={{ width: 440 }}
				stateSlice={fieldTechsState}
				targetCollectionName={TECH_TARGET_COLLECTION}
				placeholder="Filter by technician"
				allowClear
				value={filters.supplierEmail}
				onChange={(val) => {
					const email = val ? val.key || val : undefined;
					onFilterChange({ supplierEmail: email });
				}}
				fetchData={(searchText, targetCollectionName, pagination, sorting, filts, addToTarget) => {
					fetchFieldTechs(
						{ name: searchText },
						targetCollectionName,
						pagination,
						sorting,
						filts,
						addToTarget
					);
				}}
				fetchMultiple={(ids, targetCollectionName) => {
					fetchMultipleFieldTechs(ids as string[], targetCollectionName);
				}}
				valueAccessor={(el) => nullSafeGetOrElse('email', el, el.id)}
				renderRecord={(fieldTech) => (
					<Select.Option
						key={nullSafeGet('email', fieldTech)}
						value={nullSafeGet('email', fieldTech)}
					>
						{nullSafeGetOrElse('name', fieldTech, nullSafeGet('email', fieldTech))}
					</Select.Option>
				)}
				sortBy={{ sort_by: 'name', order: 'ascend' }}
			/>
			<div style={{ width: 440 }}>
				<SupplierRegionsLocationsTreeSelect
					targetCollectionName={LOCATION_TARGET_COLLECTION}
					placeholder="Filter by location"
					mode="multiple"
					value={filters.locationIds}
					onChange={(val) => {
						const ids = Array.isArray(val) && val.length > 0 ? val.map(Number) : undefined;
						onFilterChange({ locationIds: ids });
					}}
				/>
			</div>
		</div>
	);
};

export default WrenchModeLogsHeader;
